import { FC } from 'react';
import { useIntercom } from 'react-use-intercom';
import { useAppDispatch } from 'app/store';
import { openIntercomAction } from 'app/store/Mixpanel/slice';
import { Button, ButtonProps } from '@chakra-ui/react';

export const HelpLink: FC<ButtonProps> = (props) => {
  const { show } = useIntercom();
  const dispatch = useAppDispatch();

  const showIntercom = () => {
    show();
    dispatch(openIntercomAction());
  };

  return (
    <Button
      variant="link"
      onClick={showIntercom}
      fontSize="sm"
      fontWeight={500}
      ml="auto"
      whiteSpace="nowrap"
      color="M.70"
      sx={{ WebkitAppRegion: 'no-drag', border: 'none' }}
      {...props}
    >
      Need help?
    </Button>
  );
};
